export const BX_TUNE_AUTH = 'aud_web_aud3770_tune_authorization';
export const EXPERIMENTS = [BX_TUNE_AUTH];
